import { render, staticRenderFns } from "./GlossaryIndex.vue?vue&type=template&id=dfbfe31a&scoped=true&"
import script from "./GlossaryIndex.vue?vue&type=script&lang=js&"
export * from "./GlossaryIndex.vue?vue&type=script&lang=js&"
import style0 from "./GlossaryIndex.vue?vue&type=style&index=0&id=dfbfe31a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfbfe31a",
  null
  
)

export default component.exports